import { useI18n } from '~/hooks/use-i18n';

import { CatalogCardWithBasicItem } from '../components/catalog-card-program';
import { CatalogCardItem } from '../models/catalog-card-item';
import { CatalogItem } from '../models/catalog-item';
import { CatalogSearchItem } from '../models/catalog-search-result';

type CatalogItemUnion = CatalogItem | CatalogCardItem | CatalogSearchItem;

export function useLocaleCatalogTitleSummary({
  catalogItem,
  basicItem,
}: {
  catalogItem?: CatalogItemUnion;
  basicItem?: CatalogCardWithBasicItem['basicItem'];
}) {
  const { isJa } = useI18n();

  if (!catalogItem) {
    return { catalogTitle: basicItem?.title ?? '', catalogSummary: undefined };
  }

  const catalogTitle = catalogItem.title ?? '';
  const catalogSummary = 'summary' in catalogItem ? catalogItem.summary : undefined;
  const hasTitleJa = isJa && 'titleJa' in catalogItem && !!catalogItem.titleJa;
  const hasSummaryJa = isJa && 'summaryJa' in catalogItem && !!catalogItem.summaryJa;

  return {
    catalogTitle: hasTitleJa && catalogItem.titleJa ? catalogItem.titleJa : catalogTitle,
    catalogSummary: hasSummaryJa ? catalogItem.summaryJa : catalogSummary,
  };
}
